import { lazy, Suspense, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Outlet, Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
/// Style 
import './assets/scss/main.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';


import { isAuthenticated } from './store/selectors/AuthSelectors';

/// Includes

import Footer from './components/Footer';
import NavbarHeader from './components/Navbar';
import Aboutus from './pages/website/InfoPages/Aboutus';
import TrainingCourse from './pages/website/TrainingCourse';
import Error400 from './pages/error/Error400';
import Error403 from './pages/error/Error403';
import Error404 from './pages/error/Error404';
import Error500 from './pages/error/Error500';
import Error503 from './pages/error/Error503';
import CustomError from './pages/error/CustomError';
import Usp from './pages/website/InfoPages/Usp';
import ServicesAndBenefit from './pages/website/InfoPages/ServicesAndBenefit';
import Coursesbycategory from './pages/user/Coursesbycategory';
import Contact from './pages/website/InfoPages/Contact';
import PrivacyPolicy from './pages/website/PrivacyPolicy';
import TermsAndConditions from './pages/website/InfoPages/TermsAndConditions';


import HowToBecomeMitra from './pages/website/InfoPages/HowToBecomeMitra';
import Summary from './pages/website/InfoPages/Summary';
import CartPage from './pages/website/CartPage';
import BlogPage from './pages/website/BlogPage';
import Blog from './pages/website/Blog';
import Dashboard from './pages/user/Dashboard';
import MyLearning from './pages/user/MyLearning';
import Thankyou from './pages/user/thankyou/Thankyou';
import Profile from './pages/user/Profile';
import Learning from './pages/user/Learning';
import { isCheckedToken } from './services/CommonService';
import CartButton from './components/CartBottom/CartButton';

import FloatingCart from './components/FloatingCart/FloatingCart';
import QuizReport from './pages/user/UserDashboard/QuizReport';
import GradeBook from './pages/user/UserDashboard/GradeBook';
import Notification from './pages/website/Notification';
import Wishlist from './pages/website/Wishlist';
import IndianOSInitiative from './pages/website/BlogPosts/IndianOSInitiative';
import StudyHabitsPage from './pages/website/BlogPosts/StudyHabitPag';
import DigitalLiteracyGenZPage from './pages/website/BlogPosts/DigitalLiteracyGenZPage';
import MindfulnessWellBeingPage from './pages/website/BlogPosts/MindfulnessWellBeingPage';
import OnlineLearningPage from './pages/website/BlogPosts/OnlineLearningPage';
import OnlineVsOfflineLearning from './pages/website/BlogPosts/OnlineVsOfflineLearning';
import TimeManagementStudyHabits from './pages/website/BlogPosts/TimeManagementStudyHabits ';
import { fetchAllCourses } from './store2/features/coursesSlice';
import ScrollToTop from './router/Scroll/ScrollToTop';
import SpecialPageForFreeTrial from './pages/website/SpecialPageForFreeTrial';
import OtherCourseDetails from './pages/website/OtherCourseDetails';


const ForgetPassword = lazy(() => import('./pages/website/ForgetPassword/Forget1'));
const CheckEmail = lazy(() => import('./pages/website/ForgetPassword/CheckEmail'));
const ResetPassword = lazy(() => import('./pages/website/ForgetPassword/ResetPassword'));



const SignUp = lazy(() => import('./pages/website/Registration'));
const Login = lazy(() => import('./pages/website/Login'));

const HomePage = lazy(() => {
  return new Promise(resolve => {
    setTimeout(() => resolve(import('./pages/website/HomePage')), 500);
  });
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}




function App(props) {
  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const source = params.get("source");

    if (source) {
      localStorage.setItem("source", source);
      console.log("Source saved:", source);
    }
  }, [location.search]);

  const allroutes = [
    /// Dashboard
    { url: "/home", component: <HomePage /> },
    { url: "/login", component: <Login /> },
    { url: "/reset-password", component: <ResetPassword /> },
    { url: "/check-email", component: <CheckEmail /> },
    { url: "/forget-password", component: <ForgetPassword /> },
    { url: "/register", component: <SignUp /> },
    { url: "/register-free", component: <SignUp /> },
    { url: "/about-us", component: <Aboutus /> },
    { url: "/contact-us", component: <Contact /> },
    { url: "/summary", component: <Summary /> },
    { url: "/privacy-policy", component: <PrivacyPolicy /> },
    { url: "/usp", component: <Usp /> },
    { url: "/servies-and-benifit", component: <ServicesAndBenefit /> },
    { url: "/terms-and-conditions", component: <TermsAndConditions /> },

    { url: "/course-details/:id", component: <TrainingCourse /> },
    { url: "/other-course-details/:id", component: <OtherCourseDetails /> },
    { url: "/secret-course-details/:id", component: <SpecialPageForFreeTrial /> },
    { url: "/courses/:category/:subCategory", component: <Coursesbycategory /> },
    { url: "/courses/:category", component: <Coursesbycategory /> },
    { url: "/how-to-become-mitra", component: <HowToBecomeMitra /> },
    { url: "/cart", component: <CartPage /> },
    { url: "/blog", component: <BlogPage /> },
    { url: "/blogpage", component: <Blog /> },
    { url: "/pricing", component: <HomePage /> },
    { url: "/thankyou", component: <Thankyou /> },
    { url: "/quiz-report", component: <QuizReport /> },
    { url: "/notification", component: <Notification /> },
    { url: "/wishlist", component: <Wishlist /> },


    //blogposts

    { url: "/blog/IndianOSInitiative", component: <IndianOSInitiative /> },
    { url: "/blog/studyhabitpage", component: <StudyHabitsPage /> },
    { url: "/blog/DigitalLiteracyGenZPage", component: <DigitalLiteracyGenZPage /> },
    { url: "/blog/MindfulnessWellBeingPage", component: <MindfulnessWellBeingPage /> },
    { url: "/blog/OnlineLearningPage", component: <OnlineLearningPage /> },
    { url: "/blog/OnlineVsOfflineLearning", component: <OnlineVsOfflineLearning /> },
    { url: "/blog/TimeManagementStudyHabit", component: <TimeManagementStudyHabits /> },


    { url: "/", component: <HomePage /> },
  ]


  const adminRoutes = [
    { url: "/user/mylearning", component: <MyLearning /> },
    { url: "/user/dashboard/:page", component: <Dashboard /> },
    { url: "/user/dashboard", component: <Dashboard /> },

    { url: "/user/profile", component: <Profile /> },
    { url: "/learning/:id", component: <Learning /> },

    { url: "/", component: <HomePage /> }
    // { url: 'todo', component: <Todo/> },
  ]


  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  useEffect(() => {

    //checkAutoLogin(dispatch, navigate);
  }, []);

  const { pathname } = useLocation();

  useEffect(() => {
    // This finds your anchor by ID and scrolls to it immediately
    const topElement = document.getElementById("navbarHeader");
    if (topElement) {
      console.log(topElement)
      topElement.scrollIntoView({ behavior: "instant" });
    }
  }, [pathname]);



  // by shivam malik using in useapiclient in common sercice to redirect on login page
  useEffect(() => {
    const handleLogoutEvent = () => {
      navigate("/login");
    };

    window.addEventListener("logoutEvent", handleLogoutEvent);

    return () => {
      window.removeEventListener("logoutEvent", handleLogoutEvent);
    };
  }, []);

  let routeblog = (
    <Routes>
      <Route path="/custom-error" element={<CustomError />} />
      <Route path="/page-error-400" element={<Error400 />} />
      <Route path="/page-error-403" element={<Error403 />} />
      <Route path="/page-error-404" element={<Error404 />} />
      <Route path="/page-error-500" element={<Error500 />} />
      <Route path="/page-error-503" element={<Error503 />} />

      <Route element={<MainLayout />} >
        {allroutes.map((data, i) => (
          <Route
            key={i}
            exact
            path={`${data.url}`}
            element={data.component}
          />
        ))}
      </Route>

      <Route element={<AdminLayout />} >
        {adminRoutes.map((data, i) => (
          <Route
            key={i}
            exact
            path={`${data.url}`}
            element={data.component}
          />
        ))}
      </Route>



    </Routes>

  );

  const { courses } = useSelector((state) => state.courses);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!courses || courses.length === 0) {
      dispatch(fetchAllCourses());
    }
  }, [courses, dispatch]);

  return (
    <div className="vh-100">
      <Suspense fallback={
        <div className='body_wrap'>
          <div className="sk-cube-grid">
            <div className="sk-cube sk-cube1"></div>
            <div className="sk-cube sk-cube2"></div>
            <div className="sk-cube sk-cube3"></div>
            <div className="sk-cube sk-cube4"></div>
            <div className="sk-cube sk-cube5"></div>
            <div className="sk-cube sk-cube6"></div>
            <div className="sk-cube sk-cube7"></div>
            <div className="sk-cube sk-cube8"></div>
            <div className="sk-cube sk-cube9"></div>
          </div>
        </div>


      }
      >

        {routeblog}

      </Suspense>
    </div>
  );

};

const mapStateToProps = (state) => {

  if (isCheckedToken()) {
    localStorage.removeItem('userDetails');
  }

  return {
    isAuthenticated: isAuthenticated(state),
  };
};

function MainLayout() {

  return (
    <>
      <div id="main-wrapper" className={`show    `}>
        {/* <Header /> */}
        <ScrollToTop />
        <NavbarHeader />

        <div className="content-body" >
          <ToastContainer position="bottom-right" />
          <Outlet />

        </div>
        <CartButton />
        {/* <FloatingCart /> */}


        <Footer />
      </div>
    </>
  )
};


function AdminLayout() {
  const navigate = useNavigate();
  let status = mapStateToProps();

  if (status.isAuthenticated) {


  } else {
    console.log('-not login---------------')
    navigate('./login');
    //return ;
  }
  return (
    <>
      <ScrollToTop />
      <NavbarHeader />
      <ToastContainer position="top-left" />
      {status.isAuthenticated && <Outlet />}
      {(!status.isAuthenticated) && <>

        <div className='sectionWrapper '>
          <div className='container my-4 py-4'>
            <div className='row'>
              <div className='col-md-6 offset-md-3'>

                <div className='alert alert-danger text-center'> You don't have permission to access the page </div>

              </div>
            </div>
          </div>
        </div>


      </>}
      <CartButton />
      {/* <FloatingCart /> */}

      <Footer />
    </>

  )
};




export default withRouter(connect(mapStateToProps)(App)); 